// Author Lin
// Date 2021-10-03 15:52:30

import * as model from "@/model/mintalMes/prd/MintalMesPrdSmeltingFurnaceMeasureModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesPrdSmeltingFurnaceMeasure(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_PRD_URL,
    })
    .buildStore()
